import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { AnsprechPersonDetails } from '@codefluegel/wowis-rest-typescript-client';
import ContactCard from '../../components/cards/ContactCard';
import DashbboardContainer from '../../components/container/DashbboardContainer';
import Config from '../../config';
import { useStore } from '../../store/context';

const DashContacts: FC = observer(() => {
  const { welcomeStore } = useStore();
  const welcomeData = welcomeStore.getWelcomeData();

  const configuration = Config[process.env.REACT_APP_CLIENT || 'wbg'];
  const currentIds = configuration.hba_ids;
  // first three contacts
  const contacts =
    welcomeData?.contacts
      ?.filter(contact => currentIds.includes(contact.user_art_id ?? ''))
      .slice(0, 3) || ([] as AnsprechPersonDetails[]);

  return (
    <DashbboardContainer
      label="Ansprechpersonen"
      btnLabel="weitere"
      linkTo="/ansprechpersonen"
    >
      <Box
        paddingBottom={2}
        width={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {contacts.length === 0 && (
          <Box
            width={1}
            height={1}
            p={4}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant="body1" color="secondary.main">
              Keine Ansprechpersonen vorhanden
            </Typography>
          </Box>
        )}
        {contacts
          .sort(
            (a, b) => Number(a.user_art_id ?? 0) - Number(b.user_art_id ?? 0),
          )
          .map(contact => (
            <Box
              width={1}
              height={1}
              key={`${contact.firstname}${contact.surname}${contact.kont?.email}`}
            >
              <ContactCard
                contact={contact}
                iconCenter
                iconOn={false}
                bgcolor="white"
                iconColor="secondary.main"
                headerBGColor="secondary.light"
              />
            </Box>
          ))}
      </Box>
    </DashbboardContainer>
  );
});

export default DashContacts;
